import Trails from "./Trails";
import TrailsReducer from "./TrailsReducer";
import {
  setTrails,
  setSuggestedTrails,
  SET_TRAILS,
  SET_SUGGESTED_TRAILS,
} from "./TrailsActions";

export {
  Trails,
  TrailsReducer,
  setTrails,
  setSuggestedTrails,
  SET_TRAILS,
  SET_SUGGESTED_TRAILS,
};
